'use client'

import { useMemo } from 'react'
import Image from 'next/image'
import useNFTMetadata from '@hooks/useNFTMetadata'
import LoadingSpinner from '@components/LoadingSpinner'

const RowCatName = ({ nft }: { nft: string }) => {
  const {
    content: {
      metadata,
      links: { image: imageUrl },
    },
  } = useNFTMetadata(nft)

  const image = useMemo(() => imageUrl, [imageUrl])

  if (!image) {
    return <LoadingSpinner size={10} />
  }

  return (
    <>
      <Image
        className="rounded-xl"
        alt={nft}
        width="40"
        height="40"
        src={image}
      />
      <p className="font-bold">{metadata?.name}</p>
    </>
  )
}

export default RowCatName
